import {useEffect, useState} from "react";
import {Input, InputGroup} from "rsuite";
import {ClockChimeTimeInputProps} from "../../../../models/ChimeSettingsSection.model";

const ClockChimeTimeInput = ({
                               label = null,
                               value,
                               maxHoursValue = 23,
                               onChange
                             }: ClockChimeTimeInputProps) => {
  const [localHours, setLocalHours] = useState("");

  useEffect(() => {
    const num = Number(value);
    setLocalHours(num < 10 ? `0${num}` : `${num}`);
  }, [value]);

  const regex = /^\d*$/;

  const handleChange = (newValue: string) => {
    if (!regex.test(newValue)) return;

    const num = Number(newValue);
    if (num >= 0 && num <= maxHoursValue) {
      setLocalHours(newValue);
    }
  };

  const handleBlur = () => {
    const num = Number(localHours);
    const clamped = Math.min(Math.max(num, 0), maxHoursValue);
    const padded = clamped < 10 ? `0${clamped}` : `${clamped}`;
    setLocalHours(padded);
    onChange(clamped);
  };

  return (
      <InputGroup style={{height: 32}}>
        <InputGroup.Addon>
          {label}
        </InputGroup.Addon>
        <Input
          value={localHours}
          onChange={handleChange}
          onBlur={handleBlur}
          style={{
             width: 20,
            textAlign: "right",
            fontSize: 20,
            color: '#072e80',
            backgroundColor: "#d8e5fa",
            borderRadius: 0
          }}
        />
        <InputGroup.Addon style={{fontSize: 20, backgroundColor: "#d8e5fa"}}>
          :
        </InputGroup.Addon>
        <Input
          value={'00'}
          style={{
            width: 20,
            textAlign: "center",
            fontSize: 20,
            color: '#343434',
            backgroundColor: "#d8e5fa",
            borderRadius: 0
          }}
        />

      </InputGroup>
  );
};

export default ClockChimeTimeInput;
